var _circle, _path, _path2, _path3, _path4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTreatmentRoom(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 63,
    height: 63,
    viewBox: "0 0 63 63",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 31.5,
    cy: 31.5,
    r: 31.5,
    fill: "#009B97"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M42.1309 38.4704L42.2676 38.1972C43.0383 36.6557 43.4395 34.956 43.4395 33.2326V25.696V20.6175V18.0782V16.8085C43.4395 16.1073 42.8711 15.5389 42.1699 15.5389H42.0722H40.7049H37.9703H32.5011H27.4225H24.8832H23.2229H21.4908C20.8391 15.5389 20.4398 16.2535 20.7813 16.8085C21.2921 17.6387 21.5626 18.5942 21.5626 19.5689V20.6175V25.696V33.4015C21.5626 35.5096 22.1866 37.5705 23.356 39.3246C24.233 40.6401 25.3911 41.7444 26.7468 42.5578L26.8289 42.607C27.9955 43.307 29.2835 43.7812 30.6255 44.0049C32.3703 44.2957 34.1597 44.1553 35.8377 43.5959L36.4605 43.3883C37.4605 43.055 38.4002 42.5626 39.2435 41.9302C40.4615 41.0167 41.4501 39.8322 42.1309 38.4704Z",
    fill: "white",
    stroke: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M34.8449 39.7599L33.9811 40.1918C33.5216 40.4216 33.0148 40.5412 32.501 40.5412C31.9872 40.5412 31.4804 40.4216 31.0208 40.1918L30.157 39.7599L29.5827 39.4727C28.9281 39.1454 28.3306 38.7147 27.8131 38.1972C27.2956 37.6797 26.8649 37.0822 26.5376 36.4276L26.2504 35.8533L26.1679 35.6883C25.7084 34.7692 25.4691 33.7556 25.4691 32.728V31.1654V29.6027V28.0401V26.4774C25.4691 25.6144 26.1687 24.9148 27.0318 24.9148H37.9702C38.8332 24.9148 39.5329 25.6144 39.5329 26.4774V28.0401V29.6027V31.1654V32.728C39.5329 33.7556 39.2936 34.7692 38.834 35.6883L38.7515 35.8533L38.4644 36.4276C38.1371 37.0822 37.7064 37.6797 37.1889 38.1972C36.6714 38.7147 36.0739 39.1454 35.4193 39.4727L34.8449 39.7599Z",
    fill: "#009B97",
    stroke: "#009B97",
    strokeLinecap: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M35 47.125V45.875V44.9375V44.4688C35 44.2099 34.7901 44 34.5312 44H32.5H30.625C30.2798 44 30 44.2798 30 44.625V45.875V47.125V47.875C30 48.1898 30.1482 48.4861 30.4 48.675L30.5667 48.8C30.7398 48.9298 30.9503 49 31.1667 49H32.5H33.8333C34.0497 49 34.2602 48.9298 34.4333 48.8L34.6 48.675C34.8518 48.4861 35 48.1898 35 47.875V47.125Z",
    fill: "white",
    stroke: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M32.501 49.6982V52.1985V52.8235",
    stroke: "white",
    strokeLinecap: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M22 12H36",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTreatmentRoom);
export default __webpack_public_path__ + "static/media/treatment_room.7dcc4e62a96c9ac3d45a169ca79198a2.svg";
export { ForwardRef as ReactComponent };